import { Button, Grid, Typography, TextField, Box, Hidden } from "@mui/material";
import { Search as IconSearch, PersonAdd as IconPersonAdd } from "@mui/icons-material";
import * as participanteService from "../../services/participanteService";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { setValue } from '../../redux/memberSearchSlice';
import DataGridBase from "../../components/common/DataGridBase"
import { useMantenimiento } from "../../hooks/useMantenimiento";

const Index = () => {
    const { isReadOnly } = useMantenimiento("participante");
    const filters = useSelector((state) => state.memberSearch.filters);
    const personList = useSelector((state) => state.person.personList);
    const [cargando, setCargando] = useState(true);
    const [results, setResults] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        participanteService.getsParticipantesResumenView()
            .then(function (data) {
                setResults(data);
                setCargando(false);
            })
            .catch(function (error) {
                setCargando(false);
                console.log(error);
            });
    }, [])

    const fetchResults = async () => {
        setCargando(true);

        await participanteService.getsParticipantesResumenViewByMemberOrRelative(filters.member, filters.relative)
            .then((data) => {
                setResults(data);
                setCargando(false);
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }

    const columns = [
        // { field: 'id', headerName: 'ID', width: 50, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'participante', headerName: 'Nombre Participante', width: 200, sortable: false, headerAlign: 'center'
            , renderCell: (cellValues) => {
                return <Link to={'/member/edit/' + cellValues.row.id} style={{ color: 'inherit' }}>{cellValues.row.participante}</Link>;
            }
        },
        // { field: 'terapeutaAsignado', headerName: 'Terapeuta Asig.', width: 200, sortable: true, headerAlign: 'center' },
        { field: 'fechaIngreso', headerName: 'Ingreso', width: 100, type: 'date'
            , valueFormatter: (value) => moment(value).format('D/MM/YYYY')
            , sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'padre', headerName: 'Padre', width: 200, sortable: false, headerAlign: 'center' },
        { field: 'madre', headerName: 'Madre', width: 200, sortable: false, headerAlign: 'center' },
        // { field: 'personasAutorizadas', headerName: 'Personas Aut.', width: 200, sortable: false, headerAlign: 'center' },
        // { field: 'lugarCasoAccidente', headerName: 'Lugar Caso Acc.', width: 150, sortable: false, headerAlign: 'center' },
    ];

    return (
        <div>
            <Grid container>
                <Grid item>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Participantes
                    </Typography>
                </Grid>
                <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                    <Grid item>
                        <Grid container item xs={12} sm={12} spacing={1}>
                            <Grid item xs={8} sm={5}>
                                <TextField
                                    // required
                                    name="member"
                                    label="Nombre Participante"
                                    value={filters.member}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "member", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            {/* <Grid item xs={8} sm={3}>
                                <TextField
                                    // required
                                    name="therapist"
                                    label="Terapeuta Asignado"
                                    value={filters.therapist}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "therapist", value: event.target.value}))
                                    }}
                                    size="small"
                                />
                            </Grid> */}
                            <Grid item xs={8} sm={4}>
                                <TextField
                                    // required
                                    name="relative"
                                    label="Nombre Familiar"
                                    value={filters.relative}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "relative", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={2} sm={2} display={"flex"} alignItems={"center"}>
                                <Button variant="outlined" fullWidth size="medium" onClick={() => { fetchResults() }}>
                                    {<Hidden smDown></Hidden>}
                                    <IconSearch />
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <DataGridBase
                                rows={results}
                                columns={columns}
                                loading={cargando}
                                disabled={isReadOnly}
                                toolbarButtons={[
                                    {
                                        text: "Nuevo",
                                        icon: <IconPersonAdd />,
                                        onClick: () => navigate("/member/edit/0")
                                    }
                                ]}
                                // onNewClick={() => navigate(`/member/edit/0`)}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}
export default Index
